import type { ENVIRONMENT } from '../../types/environment';
import { ENVIRONMENTS } from '../../constants/environments';

export class ImageService {
  public static getImageUrl(path: string, env: ENVIRONMENT = ENVIRONMENTS.DEVELOPMENT): string {
    const { environment, codeVersion } = (window as Record<string, any>).App.context;

    if (environment !== env && codeVersion) {
      return `https://cdn.branch.io/assets/${codeVersion}${path}`;
    }

    return path;
  }

  public static addBase64StringPrefix(base64: string): string {
    return `data:image/png;base64,${base64}`;
  }
}
